module.exports = __webpack_public_path__ + "static/media/new-app-fr.c0397d3f.webp";